export function readDownloadFilename(response, fallback) {
    const disposition = response.headers['content-disposition'];
    if (disposition) {
        const match = /filename\*?=(?:UTF-8'')?"?([^";\n]+)"?/i.exec(disposition);
        if (match?.[1])
            return decodeURIComponent(match[1].trim());
    }
    return fallback;
}
